
import { DemoRequest } from "@/components/DemoRequest";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const RequestDemoPage = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6Ldc8nMqAAAAADSDwtxozDQpOUiRZez_06MP4NbJ">
      <div className="pt-20">
        <DemoRequest />
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default RequestDemoPage;
